import { Course } from "./types";

export const string2Course = (course: string): Course => {
  switch (course) {
    case "algorithm":
      return Course.ALGORITHM;
    case "program":
      return Course.PROGRAM;
    case "nishishinjuku":
      return Course.NISHISHINJUKU;
    default:
      return Course.ALGORITHM;
  }
};
